import { render, staticRenderFns } from "./SchoolCodeModal.vue?vue&type=template&id=4c1425de&"
import script from "./SchoolCodeModal.vue?vue&type=script&lang=js&"
export * from "./SchoolCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports